import {ReloadButton,} from '@flexinet/ui-components';
import {Box,} from '@mantine/core';
import { useQueryClient } from '@tanstack/react-query';
import { codeRepositoriesKeys } from '../hooks/useCodeRepositoriesQuery';

export const ReloadRecordsButton = () => {
    const queryClient = useQueryClient();

    const handleReload = () => {
        queryClient.invalidateQueries({ queryKey: codeRepositoriesKeys.all });
    };

    return (
        <Box mx='s'>
            <ReloadButton onClick={handleReload}/>
        </Box>
    );
};
